export default (params) => ({
  trigger: {
    name: 'store_stock_overlay.select_main_product',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'generic_store_stock_overlay',
          'specific_store_stock_overlay',
        ],
      },
    },
    event: {
      name: 'select_item',
      params: {
        method: 'label',
      },
    },
  },
});
